import { bindable, autoinject } from 'aurelia-framework';
import { IEditedTemplate, ReportFormMode } from '../report-edit';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';

@autoinject
export class NewReportControls {
	@bindable templateName: string;
	@bindable templateIsPrivate: boolean;
	@bindable add: (params: { editedTemplate: IEditedTemplate }) => void;

	private validationController: ValidationController;

	constructor(private validationControllerFactory: ValidationControllerFactory) {
		this.validationController = validationControllerFactory.createForCurrentScope();
		ValidationRules.ensure((vm: NewReportControls) => vm.templateName)
			.required()
			.withMessageKey('ReportEditControls_Validation_NameIsRequired')
			.on(this);
	}

	async onAdd() {
		const result = await this.validationController.validate({ object: this });

		if (!result.valid) { return; }

		this.add({ editedTemplate: { name: this.templateName, isPrivate: this.templateIsPrivate } });
	}
}
